var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantPotAlt11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81597 8.29743C8.54152 8.16153 8.27096 7.99863 8.01465 7.81112C6.74233 6.88111 7.02727 5.16505 7.02727 5.16505C7.02727 5.16505 8.76932 4.86247 9.86179 5.40844V5.39424C9.86179 3.51955 11.9848 2 11.9848 2C11.9848 2 14.1078 3.51955 14.1078 5.39424V5.40844C15.2003 4.86247 16.9423 5.16505 16.9423 5.16505C16.9423 5.16505 17.2273 6.88111 15.955 7.81112C15.7154 7.98632 15.4633 8.13975 15.2073 8.26997C16.6416 8.72408 17 10.3317 17 10.3317C17 10.3317 14.9052 11.3223 13.3456 10.8914C13.1343 10.833 12.9351 10.7649 12.75 10.6892V13H18C18.5523 13 19 13.4477 19 14V15C19 15.5523 18.5523 16 18 16H17L16.0988 21.1104C16.0426 21.6169 15.6145 22 15.105 22H8.89504C8.38549 22 7.95743 21.6169 7.90116 21.1104L7 16H6C5.44772 16 5 15.5523 5 15V14C5 13.4477 5.44772 13 6 13H11.25V10.7312C11.0956 10.7902 10.9322 10.844 10.7607 10.8914C9.20107 11.3223 7.10631 10.3317 7.10631 10.3317C7.10631 10.3317 7.43414 8.75959 8.81597 8.29743Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantPotAlt11);
export default __webpack_public_path__ + "static/media/plant-pot-alt-1-1.6fe19f3f1698445254e7131d22dfe41d.svg";
export { ForwardRef as ReactComponent };